
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $23fdd3563c1b6b43$exports = {};

$parcel$export($23fdd3563c1b6b43$exports, "spectrum--dark", function () { return $23fdd3563c1b6b43$export$68dc111a79481afd; }, function (v) { return $23fdd3563c1b6b43$export$68dc111a79481afd = v; });
var $23fdd3563c1b6b43$export$68dc111a79481afd;
$23fdd3563c1b6b43$export$68dc111a79481afd = `VF2-xW_spectrum--dark`;


export {$23fdd3563c1b6b43$exports as default};
//# sourceMappingURL=vars_spectrum-dark_css.mjs.map
